export default __webpack_public_path__ + "static/media/ico_check.62ba4dc6.svg";